import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { apiSavedFilters } from "../../../services/apis/office/apiSavedFilters";
import { urlFromFilterData } from "../../../services/utilities/util";

class SavedFilters extends React.Component {
  state = {
    savedFilters: [],
  };

  componentDidMount() {
    apiSavedFilters.get().then((res) => {
      this.setState({ savedFilters: res.data });
    });
  }

  render() {
    return (
      <div className="widget widgetRightSideBar text-start mb-4">
        <div className="row">
          <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
            <p>Your Saved Filters</p>
          </div>
          <div className="col-lg-3 text-end">
            {/* <Link to="/#" className="pe-3"> */}
            <FontAwesomeIcon icon={faFilter} />
            {/* </Link> */}
          </div>
          <div className="col-lg-12 mt-4 colorBlack searchTip">
            {Object.keys(this.state.savedFilters).map((search, i) => (
              <div className="newSearchTipInner" key={i}>
                <p>{search}</p>
                <div className="row m-0 recentSearch">
                  <div className="col-12 px-0 recentBorderBottom">
                    {Object.values(this.state.savedFilters[search]).map(
                      (value, j) => (
                        <p key={value.id}>
                          <Link
                            to={
                              "?filter=" +
                              encodeURIComponent(
                                urlFromFilterData(value.filter_value)
                              )
                            }
                          >
                            {value.text}
                          </Link>
                        </p>
                      )
                    )}
                  </div>
                </div>
              </div>
            ))}
            {/* <div className="newSearchTipInner">
              <p>Search</p>
              <div className="row m-0 recentSearch">
                <div className="col-12 px-0 recentBorderBottom">
                  <p>
                    <Link>Text</Link>
                  </p>
                  <p>
                    <Link>Text</Link>
                  </p>
                  <p>
                    <Link>Text</Link>
                  </p>
                  <p>
                    <Link>Text</Link>
                  </p>
                </div>
              </div>
            </div> */}
            {/* <p>19 June 2021</p>
            <div className="row recentSearch">
              <div className="col-12 recentBorderBottom">
                <p>Market: Bengaluru</p>
                <p>Status: Active</p>
                <p>Property: Ofﬁce</p>
                <p>{"Area: >5,000 sqft"}</p>
              </div>
            </div>
            <p>19 June 2021</p>
            <div className="row recentSearch">
              <div className="col-12 recentBorderBottom">
                <p>Market: Bengaluru</p>
                <p>Status: Active</p>
                <p>Property: Ofﬁce</p>
                <p>{"Area: >5,000 sqft"}</p>
              </div>
            </div>
            <p>19 June 2021</p>
            <div className="row recentSearch">
              <div className="col-12 recentBorderBottom">
                <p>Market: Bengaluru</p>
                <p>Status: Active</p>
                <p>Property: Ofﬁce</p>
                <p>{"Area: >5,000 sqft"}</p>
              </div>
            </div>
            <p>19 June 2021</p>
            <div className="row recentSearch">
              <div className="col-12 recentBorderBottom">
                <p>Market: Bengaluru</p>
                <p>Status: Active</p>
                <p>Property: Ofﬁce</p>
                <p>{"Area: >5,000 sqft"}</p>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    );
  }
}

export default SavedFilters;

// import React, { useEffect, useState } from 'react';

// import {apiSavedFilters} from '../services/apis/apiSavedFilters'

// function SavedFilters() {
//   const [SavedFilters, setSavedFilters] = useState([]);

//   useEffect(() => {
//     _getSavedFilters();
//   }, []);

//   function _getSavedFilters() {
//     apiSavedFilters.get().then((res) => {
//       // console.log(res);
//       // let arr = _parseRecentSearches(res);
//       // this.setState({ searches:res.data });
//       setSavedFilters(res);
//     });
//   }

//   function _parseRecentSearches(searches) {
//     return searches.map((search) => {
//       console.log(search);
//       // Parse task information
//       // return search;
//     });
//   }

//   return (
//     <ul>
//       {SavedFilters.map((search) => (
//         <li key={search.id}>{search.title}</li>
//       ))}
//     </ul>
//   );
// }

// export default SavedFilters;
